export const allAcceptedFileTypes: string[] = [
  '.ai',
  '.cad',
  '.csv',
  '.doc',
  '.docx',
  '.dwg',
  '.dxf',
  '.eps',
  '.html',
  '.key',
  '.md',
  '.numbers',
  '.odt',
  '.pages',
  '.pdf',
  '.pps',
  '.ppsx',
  '.ppt',
  '.pptx',
  '.ps',
  '.psd',
  '.rtf',
  '.sdw',
  '.step',
  '.stp',
  '.tex',
  '.tif',
  '.txt',
  '.wpd',
  '.wps',
  '.xls',
  '.xlsx',
  '.xps',
  '.bmp',
  '.jpeg',
  '.jpg',
  '.png',
  '.svg',
  '.tiff',
  '.webp',
];
